
import React, { Component } from 'react'
import axios from 'axios'
import { NotificationManager } from 'react-notifications'
import 'react-notifications/lib/notifications.css';


const url = window.location.href;
const params = (new URL(url)).searchParams;
const id = params.get("productid");
const loggedInUserID = parseInt(localStorage.getItem("loggedInUserID"));
const token = localStorage.getItem("token");
class Addreview extends Component {
  constructor(props) {
    super(props)
    this.state = {
     productid :id,
     userid: loggedInUserID,
     rating: '',
     review: ''
    }
 

  }
   WaitAwhile(delay) 
  {
      return function(response)
      {
          return new Promise(resolve => {
              setTimeout(() => resolve(response), delay)
          });
      };
  }


  changeHandler = e => {
    this.setState({ [e.target.name]: e.target.value })
  }



  submitHandler = e => {
    e.preventDefault()
    console.log(this.state)
    axios
      .post('https://shoppee-clone.herokuapp.com/review', this.state, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(response => {
        
       
        console.log(response)
          NotificationManager.success('Please refresh','Added your review!');
          window.location.reload()
        
      })
      
      
      .catch(error => {
        NotificationManager.error('review not added');
        console.log(error)
      })
  }

  render() {
    const { rating ,review } = this.state
    if (token != null ) {
      return (
        <div>
          <section className="container-lg container-fluid my-5 py-1 ">
            <div className="col sm:pl-5">
              <div className="d-flex flex-column w-100 w-md-75 justify-content-center h-100">
                <form onSubmit={this.submitHandler}>
                  <h4 className='text-dark justify-content-center'>Feel free to leave any reviews !</h4>
                  
                                  <fieldset>
                                      <select name="rating" value={rating}  onChange={this.changeHandler} className="mb-2 form-select">
                                          <option value>Rating</option>
                                          <option value="⭐">⭐</option>
                                          <option value="⭐⭐">⭐⭐</option>
                                          <option value="⭐⭐⭐">⭐⭐⭐</option>
                                          <option value="⭐⭐⭐⭐">⭐⭐⭐⭐</option>
                                          <option value="⭐⭐⭐⭐⭐">⭐⭐⭐⭐⭐</option>
                                         
  
                                      </select>
                                  </fieldset>
  
                  
                  <textarea  cols="30" rows="5" className="p-2 w-100 bg-custom-text2 form-control" name="review" value={review} onChange={this.changeHandler} id="review" placeholder="Type your comment here..." required></textarea>
                  <div className="d-flex mt-3 px-lg-5 h-100  justify-content-center">
                    <button type="submit" className="px-sm-5 px-3 py-2 btn btn-dark"  defaultValue="Submit ">Add Review </button>
                  </div>
                </form>
              </div>
            </div>
          </section>
        </div>
  
      )
    }
    
  }
}

export default Addreview

